import React from 'react';
import LayoutUsuario from '@/components/navegacao/LayoutUsuario';
import PageHeader from '@/components/layout/PageHeader';
import VBox from '@/components/layout/VBox';
import HBox from '@/components/layout/HBox';
import Icon from '@mdi/react';
import { mdiLoading, mdiPlus } from '@mdi/js';
import { useAppliance } from '@/lib/useAppliance';
import { useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { ApplianceDTO } from '@webip/shared/src/dto/appliance';
import { NetworksManager } from './NetworksManager';
import Botao from '@/components/Botao';

export default function RedesPage() {
    const { applianceId } = useAppliance();
    const qc = useQueryClient();
    const addNetworkFn = React.useRef<(() => void) | undefined>();

    const queryAppliance = useQuery(
        ['appliance-redes', applianceId],
        async () => {
            const res = await axios.get<{ ok: boolean; result: ApplianceDTO }>(
                `/api/appliance/${applianceId}`,
                { withCredentials: true },
            );
            return res.data.result;
        },
        {
            enabled: !!applianceId,
            retry: false,
        },
    );

    const handleRefresh = () => {
        qc.invalidateQueries(['appliance-redes', applianceId]);
    };

    return (
        <LayoutUsuario>
            <VBox style={{ gap: '16px', padding: '16px' }}>
                <PageHeader
                    title="Redes"
                    description="Gerencie as redes LAN, WAN e túneis IPSec do appliance selecionado."
                    actions={applianceId && queryAppliance.data ? (
                        <>
                            <Botao
                                variant="primary"
                                size="md"
                                icon={mdiPlus}
                                onClick={() => addNetworkFn.current?.()}
                            >
                                Adicionar Rede
                            </Botao>
                        </>
                    ) : undefined}
                />

                {!applianceId && (
                    <p style={{ color: 'var(--color-muted)', fontStyle: 'italic' }}>
                        Selecione um appliance no menu lateral.
                    </p>
                )}

                {applianceId && queryAppliance.isLoading && (
                    <HBox style={{ justifyContent: 'center', padding: '32px' }}>
                        <Icon path={mdiLoading} size={1.5} spin />
                    </HBox>
                )}

                {applianceId && queryAppliance.data && (
                    <NetworksManager
                        appliance={queryAppliance.data}
                        onClose={() => { }}
                        onRefresh={handleRefresh}
                        onRegisterAdd={(fn) => { addNetworkFn.current = fn; }}
                    />
                )}
            </VBox>
        </LayoutUsuario>
    );
}
